module.exports = __webpack_public_path__ + "img/zh_tw.a470f82d.png";